<template>

  <div class="content">

    <Card>
      <template #title>Welcome to <br />Manager Client</template>
      <template #content>
        <p v-if="!isAuthenticated" class="m-4">Please Login</p>
      </template>
    </Card>

  </div>

</template>

<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';

const { isAuthenticated } = useAuth0();
</script>
